import { lazy } from 'react';

import { CommonRoutes } from 'common/config/routes/routes';

import RoutePaths from './route-paths';

const Routes = [
  {
    path: RoutePaths.authenticationFace,
    component: lazy(() => import('authentication/pages/face-login/face')),
  },
  {
    path: RoutePaths.authenticationFaceActive,
    component: lazy(() => import('authentication/pages/face-login/active')),
  },
  {
    path: RoutePaths.login,
    component: lazy(() => import('authentication/pages/login/login.page')),
  },
  {
    path: RoutePaths.error,
    component: lazy(() => import('authentication/pages/error')),
  },

  ...CommonRoutes,
];

export default Routes;
